import { JsonProperty } from 'json2typescript'

export default class Modification {
  @JsonProperty('carRiskVehicleModification', String)
  carRiskVehicleModification = ''
}
